"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiArrowDown } from "react-icons/pi";

export default function PortfolioHero({ content, onContentChange, isSelected }: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  return (
    <div
      className={`relative overflow-hidden py-32 bg-white text-slate-900 ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-4xl mx-auto px-6 space-y-8">
        <h1 className="text-5xl md:text-8xl font-black tracking-tighter text-slate-900 leading-[0.95]">
          <EditableText
            value={content.title || "CREATIVE DESIGNER"}
            onChange={(val) => updateContent("title", val)}
            as="span"
          />
        </h1>

        <p className="text-xl md:text-2xl text-slate-500 max-w-xl leading-relaxed">
          <EditableText
            value={content.subtitle || "Building clean interfaces, premium brandings, and unique interactive websites."}
            onChange={(val) => updateContent("subtitle", val)}
            as="span"
          />
        </p>

        <div className="pt-6">
          <a
            href={content.primaryBtnLink || "#work"}
            className="w-12 h-12 rounded-full border border-slate-350 flex items-center justify-center text-slate-900 hover:bg-slate-900 hover:text-white transition-all shadow-xs"
          >
            <PiArrowDown className="w-5 h-5 animate-bounce" />
          </a>
        </div>
      </div>
    </div>
  );
}
